import { StyledTable } from '@/shared/ui/tables'
import React, { Component } from 'react'
import {
    Paper,
    Select,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import { LoadingDefault } from '@/shared/ui/loading'

class DisplayItemLinkSortSettings extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            sortSettings: this.props.sort ? this.props.sort : [],
            ddis: [],
        }
        this.changeSort = this.changeSort.bind(this)
    }

    changeSort(e, ddiItem) {
        let sortSettings = this.state.sortSettings.filter(
            (item) =>
                ddiItem.def_dossier_def_field &&
                parseInt(item.dddfId) !== ddiItem.def_dossier_def_field.id
        )

        if (e.target.value) {
            sortSettings.push({
                dddfId: ddiItem.def_dossier_def_field.id,
                sort: e.target.value,
            })
        }

        this.setState({ sortSettings: sortSettings })
        this.props.onChangeSort(sortSettings)
    }

    fetchListItems() {
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.getCached(api.getDisplayItemEndpoint(), {
            params: {
                defDossier: this.props.defDossierId,
                view: 'list',
                limit: 500,
            },
        }).then((response) =>
            this.setState({
                loading: false,
                ddis: response.data.results.filter(
                    (item) => item.def_dossier_def_field
                ),
            })
        )
    }

    componentDidMount() {
        this.fetchListItems()
    }

    render() {
        const kedo = this.props.kedo

        return (
            <div>
                <h3>{kedo.t('Default sorting')}</h3>
                {this.state.loading ? <LoadingDefault /> : null}
                <TableContainer component={Paper}>
                    <StyledTable size="small" striped>
                        <TableBody>
                            {this.state.ddis.map((ddiItem) => {
                                let existingVal = this.state.sortSettings.find(
                                    (item) =>
                                        parseInt(item.dddfId) ===
                                        ddiItem.def_dossier_def_field.id
                                )

                                return (
                                    <TableRow key={`sort-${ddiItem.id}`}>
                                        <TableCell>
                                            {kedo
                                                .env()
                                                .translateItem(
                                                    ddiItem,
                                                    'displayitem'
                                                )}
                                        </TableCell>
                                        <TableCell>
                                            <Select
                                                size="small"
                                                displayEmpty
                                                native
                                                value={
                                                    existingVal
                                                        ? existingVal.sort
                                                        : ''
                                                }
                                                onChange={(e) =>
                                                    this.changeSort(e, ddiItem)
                                                }
                                                name={`sort-${ddiItem.id}`}
                                                key={`dd-sort-${ddiItem.id}`}
                                                disabled={this.props.disabled}
                                            >
                                                <option value={''}>
                                                    {kedo.t('Choose an option')}
                                                </option>
                                                <option value={'ASC'}>
                                                    {kedo.t('ASC')}
                                                </option>
                                                <option value={'DESC'}>
                                                    {kedo.t('DESC')}
                                                </option>
                                            </Select>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </div>
        )
    }
}

export default DisplayItemLinkSortSettings
